/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import FormEdi from './FormEdi';
import FormGeneric from './FormGeneric';
import FormEdiRegionTwo from './FormEdiRegionTwo';

export default function IncidentEDIForm({
    register, comments, errors, setFiles, setValue, usrId, isRegionTwo
}) {
    const ediFormComponent = (<> <br/> <FormEdi
        register={register}
    /> <br/> <FormGeneric
        comments={comments}
        errors={errors}
        register={register}
        setFiles={setFiles}
        setValue={setValue}
        usrId={usrId}
    /> </>);

    const regionTwoFormComponent = (<> <br/> <FormEdiRegionTwo
        errors={errors}
        register={register}
    /> <br/> <FormGeneric
        comments={comments}
        errors={errors}
        register={register}
        setFiles={setFiles}
        setValue={setValue}
        usrId={usrId}
    /> </>);

    return isRegionTwo ? regionTwoFormComponent : ediFormComponent;
}
